// extracted by mini-css-extract-plugin
module.exports = {"small":"screen and (max-width: 599px)","medium":"screen and (min-width: 600px) and (max-width: 959px)","large":"screen and (min-width: 960px) and (max-width: 1199px)"};